import { render, staticRenderFns } from "./Metrica.vue?vue&type=template&id=60f47ad7&scoped=true"
import script from "./Metrica.vue?vue&type=script&lang=js"
export * from "./Metrica.vue?vue&type=script&lang=js"
import style0 from "./Metrica.vue?vue&type=style&index=0&id=60f47ad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f47ad7",
  null
  
)

export default component.exports